import React from "react";
import { Routes, Route } from "react-router-dom";
import ReactLogin from "../pages/ReactLogin";
import Login from "../pages/Login";

function AuthRoutes() {
  return (
    <Routes>
      {/* for desktop app */}
      {/* <Route path="" element={<Login />} /> */}

      {/* for web browser */}
      <Route path="" element={<ReactLogin />} />
    </Routes>
  );
}

export default AuthRoutes;
